export enum EApiEndpointField {
  DESCRIPTION = "DESCRIPTION",
  PARAMETERS = "PARAMETERS",
  TAGS = "TAGS",
}
